import {
  Report5SAuditsState,
  Report5SAuditsActions,
  Report5SAuditsActionTypes,
} from '../../types/report5SAudits';

const initialState: Report5SAuditsState = {
  chart: { data: null, loading: false, error: null },
};

export const report5SAudits = (state = initialState, action: Report5SAuditsActions): Report5SAuditsState => {
  switch (action.type) {
    case Report5SAuditsActionTypes.LOAD_CHART_REQUEST:
      return { ...state, chart: { ...state.chart, loading: true, error: null } };

    case Report5SAuditsActionTypes.LOAD_CHART_SUCCESS:
      return { ...state, chart: { data: action.payload.data, loading: false, error: null } };

    case Report5SAuditsActionTypes.LOAD_CHART_FAILURE:
      return { ...state, chart: { ...state.chart, loading: false, error: action.payload.error } };

    case Report5SAuditsActionTypes.CLEAR_CHART:
      return { ...state, chart: { data: null, loading: false, error: null } };

    default:
      return state;
  }
};
